import { useEffect, useState } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../../firebase/FirebaseConfig"; // Adjust this import path
import { RoomDayTimeType } from "../../../firebase/models"; // Adjust this import path

export const useRoomDayTime = () => {
  const [roomDayTime, setRoomDayTimeState] = useState<RoomDayTimeType | null>(
    null
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Fetch RDT data on mount
  useEffect(() => {
    const fetchRoomDayTime = async () => {
      try {
        const docRef = doc(db, "clubRoomDayTime", "RoomDayTime");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();
          setRoomDayTimeState(data.RDT as RoomDayTimeType);
        } else {
          setError("RoomDayTime document not found.");
        }
      } catch (err) {
        setError("Failed to fetch RoomDayTime.");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchRoomDayTime();
  }, []);

  // Function to update RDT in Firestore and local state
  const updateRoomDayTime = async (newData: RoomDayTimeType) => {
    try {
      const docRef = doc(db, "clubRoomDayTime", "RoomDayTime");
      await setDoc(docRef, { RDT: newData }, { merge: true });
      setRoomDayTimeState(newData);
    } catch (err) {
      setError("Failed to update RoomDayTime.");
      console.error(err);
    }
  };

  return {
    roomDayTime,
    loading,
    error,
    updateRoomDayTime,
  };
};
